import { useState } from 'react'

import { ActionIcon, Collapse, Loader } from '@mantine/core'
import { Check, X } from 'lucide-react'

import DNButton from 'src/components/Buttons/Button/DNButton'
import DateInput from 'src/components/Inputs/DateInput/DateInput'
import IconChevronDown from 'src/icons/IconChevronDown'
import IconEdit from 'src/icons/IconEdit'

import TextInput from '../TextInput/TextInput'

const TwicInformationCard = ({
  values: appValues = [],
  handleUpdateApplication,
}) => {
  const [values, setValues] = useState({ ...appValues[0] })
  const [editing, setEditing] = useState(false)
  const [opened, setOpened] = useState(true)
  const [loading, setLoading] = useState(false)

  const handleEdit = () => {
    setEditing(true)
  }

  const handleCancel = () => {
    setValues({ ...appValues[0] })
    setEditing(false)
  }

  const handleSave = async () => {
    setLoading(true)
    try {
      let updates = {}
      updates = { twicCard: { ...values } }
      const result = await handleUpdateApplication(updates)
      if (!result.errors) {
        setEditing(false)
      }
    } catch (error) {
      // Error handled by mutation
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex w-full flex-col gap-2 rounded-lg border border-doubleNickel-gray-200 p-3">
      <div
        className="text-md flex w-full cursor-pointer flex-row items-center gap-2 font-semibold text-doubleNickel-gray-900"
        onClick={() => setOpened((prev) => !prev)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            setOpened((prev) => !prev)
          }
        }}
        role="button"
        tabIndex={0}
        aria-expanded={opened}
      >
        <ActionIcon variant="subtle" className="pointer-events-none">
          <IconChevronDown
            className={`h-4 w-4 ${
              !opened && '-rotate-90'
            } fill-none stroke-doubleNickel-gray-500 transition-all`}
          />
        </ActionIcon>
        TWIC
        {!editing ? (
          <DNButton
            variant="transparent"
            onClick={(e) => {
              e.stopPropagation()
              if (!opened) setOpened(true)
              handleEdit()
            }}
            className="ml-auto text-doubleNickel-gray-700"
          >
            <IconEdit className="h-3.5 w-3.5 fill-none stroke-current" />
            Edit
          </DNButton>
        ) : (
          <div className="ml-auto flex items-center gap-2">
            <DNButton
              variant="transparent"
              onClick={(e) => {
                e.stopPropagation()
                handleSave()
              }}
              disabled={loading}
              className="text-doubleNickel-success-500"
            >
              <Check size={14} />
              Save
            </DNButton>
            <DNButton
              variant="transparent"
              onClick={(e) => {
                e.stopPropagation()
                handleCancel()
              }}
              disabled={loading}
              className="text-doubleNickel-error-500"
            >
              <X size={14} />
              Cancel
            </DNButton>
            {loading && <Loader size={12} color="gray" />}
          </div>
        )}
      </div>
      <Collapse in={opened} transitionDuration={400}>
        <div className="flex flex-col gap-2">
          <div className="flex flex-col gap-2">
            <TextInput
              label="TWIC Number"
              placeholder="No TWIC Number Found"
              editing={editing}
              value={values.cardNumber}
              handleChange={(value) => setValues({ ...values, cardNumber: value })}
            />
            <DateInput
              label="TWIC Expiration Date"
              editing={editing}
              value={values.expirationDate}
              onChange={(value) => {
                setValues({ ...values, expirationDate: value })
              }}
            />
          </div>
        </div>
      </Collapse>
    </div>
  )
}

export default TwicInformationCard
